import Client from "../AxiosClient";
const resource = "/private/informs";

export default {

    async getLatest (params) {
        try {
            const result = await Client.get(`${resource}/latest`, {params});
            return result;
        } catch (error) {
            return {
                status: 'failed',
                data: [],
                message: error
            }
        }
    },

}